"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderValueForUI = exports.getAmountUomString = exports.formatCurrencyForDisplay = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.formatCurrencyForDisplay = (priceToFormat, options = {
    charLimitToShow: 4,
    decimalsToShow: 2,
}) => {
    const { charLimitToShow, decimalsToShow } = options;
    const price = parseFloat(priceToFormat || '');
    if (lodash_1.default.isNaN(price)) {
        return '';
    }
    const formattedPrice = price.toString();
    if (lodash_1.default.includes(formattedPrice, '.')) {
        const numberSplit = formattedPrice.split('.');
        const integerPart = numberSplit[0];
        const decimalPart = numberSplit[1].slice(0, decimalsToShow);
        const numberOfCharsInIntegerPart = lodash_1.default.size(integerPart);
        const formattedPriceWithCorrectNumberOfDecimals = `${integerPart}.${decimalPart}`;
        return `$ ${lodash_1.default.padStart(formattedPriceWithCorrectNumberOfDecimals, charLimitToShow - numberOfCharsInIntegerPart)}`;
    }
    else {
        return `$ ${lodash_1.default.padStart(formattedPrice, charLimitToShow - formattedPrice.length)}.00`;
    }
};
exports.getAmountUomString = (amount, uom) => {
    const valueToEdit = lodash_1.default.isString(amount) ? Number(amount) : amount;
    if (valueToEdit == null) {
        return uom;
    }
    let output = '';
    if (lodash_1.default.isNumber(amount) && !lodash_1.default.isNaN(amount)) {
        output = Number(amount.toFixed(2)).toString();
    }
    else {
        if (lodash_1.default.isNaN(valueToEdit)) {
            output = '';
        }
        else {
            output = Number(valueToEdit.toFixed(2)).toString();
        }
    }
    if (uom) {
        output = `${output} ${uom}`;
    }
    return output;
};
exports.renderValueForUI = (value) => {
    if (value == null) {
        return '';
    }
    else if (lodash_1.default.isNumber(value)) {
        return String(value);
    }
    else {
        return lodash_1.default.startCase(value);
    }
};
//# sourceMappingURL=data:application/json;base64,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